import React from 'react';
import { Empty, Spin, Input } from 'antd';
import { SearchOutlined, ShoppingOutlined } from '@ant-design/icons';
import ProductCard from './ProductCard';
import { Product, ProductOrderItem } from '../../types/products';

const { Search } = Input;

interface ProductGridProps {
  products: Product[];
  onAddToOrder: (orderItem: ProductOrderItem) => void;
  loading?: boolean;
  searchQuery?: string;
  onSearchChange?: (query: string) => void;
  /** productId -> units pending in the unsent order, shown as a badge on each card. */
  cartQuantities?: Record<string, number>;
  compact?: boolean; // Kept for compatibility
  reducedLayout?: boolean; // Kept for compatibility
}

const ProductGrid: React.FC<ProductGridProps> = ({
  products,
  onAddToOrder,
  loading = false,
  searchQuery = '',
  onSearchChange,
  cartQuantities,
}) => {
  const filteredProducts = products.filter(product =>
    product.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
    (product.description?.toLowerCase().includes(searchQuery.toLowerCase()) ?? false)
  );

  if (loading) {
    return (
      <div style={{ textAlign: 'center', padding: '50px 0' }}>
        <Spin size="large" />
        <div style={{ marginTop: 16 }}>Cargando productos...</div>
      </div>
    );
  }

  return (
    <div>
      {onSearchChange && (
        <div style={{ marginBottom: 16 }}>
          <Search
            placeholder="Buscar productos..."
            allowClear
            value={searchQuery}
            onChange={(e) => onSearchChange(e.target.value)}
            style={{ maxWidth: '100%' }}
            prefix={<SearchOutlined />}
          />
        </div>
      )}

      {filteredProducts.length === 0 ? (
        <Empty
          image={<ShoppingOutlined style={{ fontSize: 64, color: 'var(--border-color-strong)' }} />}
          description={
            searchQuery
              ? `No se encontraron productos para "${searchQuery}"`
              : 'No hay productos disponibles'
          }
        />
      ) : (
        <div className="product-tile-grid">
          {filteredProducts.map((product) => (
            <ProductCard
              key={product.id}
              product={product}
              onAddToOrder={onAddToOrder}
              quantityInCart={cartQuantities?.[product.id] ?? 0}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default ProductGrid;
